import { render, staticRenderFns } from "./onlineDeclaration.vue?vue&type=template&id=79f539c0&scoped=true"
import script from "./onlineDeclaration.vue?vue&type=script&lang=js"
export * from "./onlineDeclaration.vue?vue&type=script&lang=js"
import style0 from "./onlineDeclaration.vue?vue&type=style&index=0&id=79f539c0&lang=scss"
import style1 from "./onlineDeclaration.vue?vue&type=style&index=1&id=79f539c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f539c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f539c0')) {
      api.createRecord('79f539c0', component.options)
    } else {
      api.reload('79f539c0', component.options)
    }
    module.hot.accept("./onlineDeclaration.vue?vue&type=template&id=79f539c0&scoped=true", function () {
      api.rerender('79f539c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/components/onlineDeclaration.vue"
export default component.exports